export default{
    outInvoice:{
        Headers:{
            title:"账期支付的订单将在账期结算时统一开具发票",
            title1:"发票管理",
            title2:"选择商家",
            title3:"选择订单",
            title4:"选择抬头",
        },
        form:{
            query:"订单号",
            invoApplyStatus:"发票状态",
            datepicker:"支付时间",
            defaultFlag:"默认抬头", 
            defaultFlag1:"设为默认",
            price:"可开票金额",   
            shopName:"开票商家",  
            invoTitle:"发票抬头",
            applyRemarks:"备注信息",
        },
        placeholder:{
            query:"请输入订单编号",
            invoApplyStatus:"全部",
            datepicker:["开始时间","结束时间"],
            applyRemarks:"该备注信息会展示在发票上,如有需要请录入,否则无需录入任何信息"
        },
        steps:{
            step:"选择开票商家",
            step1:"选择待开票数据",
            step2:"确定发票信息和地址",
        },
        rules:{invoTitle:"请选择发票抬头"},
        Message:{
               warning:"请选择待开票的数据！！！",
               success:"开票成功"
        },
        Alert:{

        },
        Button:{
            btndraft:"立即开票",
            goInvo:'去开票',
            btnInvoTile:"管理发票抬头",
            btnSeach:"搜索",
            btnReset:"重置",
            btnDetail:"查看详情",
            btnConfirm:"确定",
            btnstep:"上一步",
            btnNext:"下一步",
            addInvoices:"修改抬头"
        },
        Placeholder:{

        },
        Validate:{

        },

        Description:{
            noData:'暂无发票',
            emptyText:"暂无数据",
            emptyText1:"建议不要超过25个汉字或50个（数字+字母），否则盖章的时候有可能压到",
        },
        Table:{
            headerName:['商家名称','可开票订单数','订单金额','退款金额','可开票金额','操作'],
            headerName1:['订单编号','商家名称','订单金额','退款金额','可开票金额','支付时间','操作'],
        }
    }
    
}